import axios from "axios";
import { NotificationManager } from "/@src/components/common/react-notifications";
import { api } from "/@src/network/auth";
import { GET_MEDIA, LIST_MEDIA, SET_MEDIA_LOADING } from "/@src/redux/contants";
import { getUserDetails } from "../auth/actions";
import { rewriteMediaUrl } from "/@src/helpers/Utils";

export const listMedia = () => {
  return async (dispatch) => {
    dispatch({
      type: SET_MEDIA_LOADING,
      payload: true,
    });
    try {
      const res = await api.get(`/media`);
      const data = res.data;

      return dispatch({
        type: LIST_MEDIA,
        payload: data,
      });
    } catch (e) {
      console.log(e);
      NotificationManager.error(e.message, "List Media Failed", 3000);
    } finally {
      dispatch({
        type: SET_MEDIA_LOADING,
        payload: false,
      });
    }
  };
};

export const getMedia = (id) => {
  return async (dispatch) => {
    dispatch({
      type: SET_MEDIA_LOADING,
      payload: true,
    });
    try {
      const res = await api.get(`/media/${id}`);
      const data = res.data;

      return dispatch({
        type: GET_MEDIA,
        payload: data,
      });
    } catch (e) {
      console.log(e);
    } finally {
      dispatch({
        type: SET_MEDIA_LOADING,
        payload: false,
      });
    }
  };
};

export const saveMedia = (mediaFile, msg = "Media Upload Sucessful") => {
  return async (dispatch) => {
    try {

      const type = mediaFile.type || 'application/octet-stream';
      const { data } = await api.post("/media/signedUrl", {
        fileName: mediaFile.name,
        fileSizeKb: (mediaFile.size / 1024).toFixed(2),
        mimeType: type
      } );
      await axios.create().put(
        rewriteMediaUrl(
        data.preSignedUrl), 
        mediaFile, {
        headers: {
          "Content-Type": data.media.mimeType,
        },
      });
      NotificationManager.success(msg, "Media Created", 3000);

      dispatch({
        type: GET_MEDIA,
        payload: data,
      });
      dispatch(getUserDetails());
      return data.media;
    } catch (e) {
      console.log(e);
      NotificationManager.error(e.message, "Media Upload Failed", 3000);
      throw e;
    }
  };
};

export const deleteMedia = (mediaId, msg = "Media Delete Sucessful") => {
  return async (dispatch) => {
    try {
      await api.delete(`/media/${mediaId}`);
      NotificationManager.success(msg, "Media Deleted", 3000);
      dispatch(getUserDetails());
    } catch (e) {
      NotificationManager.error(e.message, "Media Deletion Failed", 3000);
      throw e;
    }
  };
};
